import React, { useState } from 'react';
import { File, Image } from 'lucide-react';

export function communityFileIsRasterImagePreview(file) {
  if (!file?.url) return false;
  const mime = String(file.type || '').toLowerCase();
  if (mime.includes('svg')) return false;
  if (mime.startsWith('image/')) return true;
  const ext = file.name?.split('.').pop()?.toLowerCase();
  return ext && ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'].includes(ext);
}

function getFileIcon(fileName) {
  const extension = fileName?.split('.').pop()?.toLowerCase();
  const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'];
  if (imageExtensions.includes(extension)) {
    return <Image className="w-4 h-4" />;
  }
  return <File className="w-4 h-4" />;
}

const CommunityAttachmentThumb = ({ file, className }) => {
  const [imgError, setImgError] = useState(false);
  const showImage = communityFileIsRasterImagePreview(file) && !imgError;

  if (showImage) {
    return (
      <img
        src={file.url}
        alt={file.name || ''}
        className={className}
        loading="lazy"
        onError={() => setImgError(true)}
      />
    );
  }

  return (
    <div
      className={`flex items-center justify-center bg-gray-100 dark:bg-gray-600 ${className}`}
      aria-hidden
    >
      {getFileIcon(file.name)}
    </div>
  );
};

export default CommunityAttachmentThumb;
